import { Resources } from 'constants/resources';

import { useGoBack } from 'hooks/useGoBack';
import { RaRecord, useNotify, useRedirect } from 'react-admin';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { EditGuesserPage } from 'shared/react-admin/Pages/EditGuesserPage/EditGuesserPage';
import { OrderStatus } from 'types/embedded/orderStatus';
import { Role } from 'types/embedded/role';

import { RolesEditForm } from './RolesEditForm';

const transform = ({ roleCategories, ...data }: RaRecord): RaRecord => ({
  ...data,
  roleCategories: Array.isArray(roleCategories) ? roleCategories[0] : roleCategories,
  allowedStatusesEditing: data.allowedStatusesEditing.map(
    (status: OrderStatus) => status?.value || status,
  ),
});

export const RolesEdit: React.FC = () => {
  const { goBack } = useGoBack();
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (role: Role) => {
    notify(
      <>
        Роль <TypographyBold text={role.name} /> изменена
      </>,
      { type: 'success' },
    );
    redirect('list', Resources.Roles);
  };

  return (
    <EditGuesserPage
      listName="Роли"
      mutationOptions={{ onSuccess, onError: () => undefined }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" onClick={goBack} variant="outlined" />,
        <SaveButtonValidated key="save-button" label="Сохранить" />,
      ]}
      title="Редактирование роли"
      transform={transform}
    >
      <RolesEditForm />
    </EditGuesserPage>
  );
};
